export default __webpack_public_path__ + "static/IMG-006b48ef72fdc2eace7c8ed79e5738a3.png";